import React, { useId, KeyboardEvent } from "react";
import cls from "./styles.module.scss";

interface TextareaProps {
  id?: string;
  label?: string;
  placeholder?: string;
  value: string;
  disabled?: boolean;
  required?: boolean;
  rows?: number;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  className?: string;
}

const Textarea: React.FC<TextareaProps> = ({
  id,
  label,
  placeholder,
  value,
  disabled = false,
  required,
  rows = 4,
  onChange,
  onFocus,
  onKeyDown,
  className,
}) => {
  const generatedId = useId();
  const textareaId = id || generatedId;

  return (
    <div className={cls.inputContainer}>
      {label && (
        <label className={cls.label} htmlFor={textareaId}>
          {required && <span>* </span>}
          {label}
        </label>
      )}

      <div className={cls.inputWrapper}>
        <textarea
          id={textareaId}
          className={`${cls.textarea} ${
            disabled ? cls.disabledTextarea : ""
          } ${className}`}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          rows={rows}
          onFocus={onFocus}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
        />
      </div>
    </div>
  );
};

export default Textarea;
